import React from 'react'

import Suggestions from './Suggestions.jsx'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'
import ButtonGroupRadio from './ButtonGroupRadio.jsx'

import { translate } from 'react-i18next';
var PrequalForm = React.createClass({

  getInitialState() {
    var state = AvailabilityStore.getState();

  	if(state.get('auto_prequal')) {
		window.dataLayer.push ({
			'event': 'eec.checkout',
			'ecommerce': {
			  'checkout': {
				'actionField': {
				  'step': '2'
				},
			  }
			}
		})
		AvailabilityActions.prequalStart(state.toJS());
  	}

    return {store: state};
  },

  componentDidMount() {
	var state = AvailabilityStore.getState();
	AvailabilityActions.loadedAvailForm(state.get('auto_prequal')); // auto_prequal is set if this form was started in a different react app and passed in thus we don't want to double count the form load
	AvailabilityStore.listen(this.onChange);
	document.body.classList.remove('long-scroll'); // Need body styles on the long-scroll page. This makes sure it is removed if the user goes to try a new address.
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state });
  },

	prequalStart(event) {

		AvailabilityActions.prequalStart(this.state.store.toJS());
		window.dataLayer.push ({
			'event': 'eec.checkout',
			'ecommerce': {
			  'checkout': {
				'actionField': {
				  'step': '2'
				},
			  }
			}
		})
   		event.preventDefault();
    	event.stopPropagation();
    	return false;
	},

	updateZip(event) {
	    if(event.type == 'click') {
	      return;
	    }
	    AvailabilityActions.updateZip(event.target.value);
	},

	updateSecondary(event) {
	    if(event.type == 'click') {
	      return;
	    }
	    AvailabilityActions.updateSecondary(event.target.value);
	},

	updateServiceType(event) {
		AvailabilityActions.updateServiceType(event.target.value);
	},

	streetAddressBlur() {
		AvailabilityActions.verifyInput(this.state.store.toJS());
	},

  render() {
	const { t } = this.props;

	var store = this.state.store;

	var radioButtons = [
		'residential',
		'business'
	];
	var service_type = store.getIn(['input_address', 'serviceType']);
	var pqform = this;

	var is_valid = (store.getIn(['input_address', 'streetAddress_valid'])  && store.getIn(['input_address', 'zip_valid']) ? true : false);

	var verification_message;
	if(store.get('verification_failed')) {
		verification_message = <div className="col-sm-12"><div className="alert alert-info text-center verification-failed">
             {t('common:address_not_recognized')}
        </div></div>;
	}

  	return (
			<form onSubmit={this.prequalStart} key="prequalform">

				<div className="row">
				<div className="col-sm-12">

				<div className="text-center">
					<h1 className="check_avail_header">{t('common:check_avail_header')}</h1>
					<p>{t('common:enter_address_description')}</p>
				</div>

				<div className="row">

					<div className="col-sm-12 form-group">
						<label htmlFor="street_address">
							{t('common:street_address_label')}
						</label>
						<Suggestions />
					</div>

					<div className="col-sm-6 form-group">
						<label htmlFor="zip_code">{t('common:zip_code_label')}</label>
						<input type="text" name="zip_code" value={store.getIn(['input_address', 'zip'])} onInput={this.updateZip} onBlur={this.streetAddressBlur} className="form-control" id="zip_code" placeholder={t('common:zip_code_placeholder')} />
					</div>

					<div className="col-sm-6 form-group">
						<label htmlFor="secondary">{t('common:secondary_label')}</label>
						<input type="text" name="secondary" value={store.getIn(['input_address', 'secondary'])} onInput={this.updateSecondary} className="form-control" id="secondary" placeholder={t('common:secondary_placeholder')} />
					</div>

					<div className="col-sm-12 form-group">
						<fieldset>
							<legend id="service_type_label">{t('common:service_type_label')}</legend>
							<div className="btn-group btn-group-radio service-type-group">

								{radioButtons.map(function(radio) {
									var inputProps = {};
									inputProps.value = radio;
									inputProps.radioValue = service_type;
									inputProps.name = 'service_type';
									inputProps.onChange = pqform.updateServiceType;

								return <ButtonGroupRadio inputProps={inputProps} key={inputProps.value} />;
								})}

							</div>
						</fieldset>
					</div>

						{verification_message}
					</div>

					<div className="text-center check-availability-button-container">
						<button type="submit" className={"btn btn-lg check-availability-button"+(is_valid ? " " : " disabled")} >{t('common:check_availability_button')}</button>
					</div>
				</div>
				</div>

			</form>
  	)
  }
});

export default  translate('common', { wait: true })(PrequalForm);